// Mobile product gallery arrows: the buttons target this element with commandfor and step the scroll-snap track one photo at a time.
class SGalleryArrows extends HTMLElement {
  #abort;

  connectedCallback() {
    this.#abort = new AbortController();
    const { signal } = this.#abort;
    this.track = this.querySelector('[data-product-gallery]');
    this.prev = this.querySelector('[data-gallery-prev]');
    this.next = this.querySelector('[data-gallery-next]');
    if (!this.track) return;

    this.addEventListener(
      'command',
      (event) => {
        if (event.command === '--previous') this.#step(-1);
        if (event.command === '--next') this.#step(1);
      },
      { signal },
    );
    this.track.addEventListener('scroll', () => this.#sync(), { signal, passive: true });
    window.addEventListener('resize', () => this.#sync(), { signal, passive: true });
    this.#sync();
  }

  disconnectedCallback() {
    this.#abort?.abort();
  }

  #step(direction) {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    // In RTL the track scrolls toward negative scrollLeft values.
    const sign = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
    this.track.scrollBy({
      left: direction * sign * this.track.clientWidth,
      behavior: reduceMotion ? 'auto' : 'smooth',
    });
  }

  #sync() {
    const max = this.track.scrollWidth - this.track.clientWidth;
    const position = Math.abs(this.track.scrollLeft);
    if (this.prev) this.prev.disabled = position <= 2;
    if (this.next) this.next.disabled = position >= max - 2;
  }
}

if (!customElements.get('s-gallery-arrows')) customElements.define('s-gallery-arrows', SGalleryArrows);
